/** The editor view used while creating or editing a prescription job. */
export enum PrescriptionState {
  /** Single field prescription view */
  SINGLE_FIELD_PRESCRIPTION = 'SINGLE_FIELD_PRESCRIPTION',

  /**
   * A bulk job is showing one field, either after shared intervals are applied or because its
   * model has no overview.
   */
  BULK_PRESCRIPTION_SINGLE_FIELD_VIEW = 'BULK_PRESCRIPTION_SINGLE_FIELD_VIEW',

  /** A bulk job is showing the combined fields before shared intervals are applied. */
  BULK_PRESCRIPTION_OVERVIEW = 'BULK_PRESCRIPTION_OVERVIEW',
}
